module.exports = __webpack_public_path__ + "img/fbbz-top.aeb63f73.png";